import { render, staticRenderFns } from "./DeploymentTestingPanel.vue?vue&type=template&id=60d066a1&scoped=true&"
import script from "./DeploymentTestingPanel.vue?vue&type=script&lang=js&"
export * from "./DeploymentTestingPanel.vue?vue&type=script&lang=js&"
import style0 from "./DeploymentTestingPanel.vue?vue&type=style&index=0&id=60d066a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d066a1",
  null
  
)

export default component.exports